import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ActionButton from 'components/common/ActionButton';

const ListCalendarEvents = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setError(null);
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/calendar-events/list`);
        setNews(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const archiveArticle = async (id, title) => {
    if (window.confirm(`Are you sure you want to delete this event: ${title}?`)) {
      try {
        setError(null);
        const response = await axios.put(`${process.env.REACT_APP_API_URL}/calendar-events/archive/id/${id}`);
        console.log(response.data);
        setNews(news.filter((event) => event.id !== id));
      } catch (error) {
        console.log('error', error);
        setError(error.message);
      }
    }
  };

  return (
    <>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div>Error: {error}</div>
      ) : (
        <Table hover responsive>
          <thead>
            <tr>
              <th scope="col">Title</th>
              <th scope="col">Status</th>
              <th scope="col">Starts</th>
              <th scope="col">Venue</th>
              <th className="text-end" scope="col">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {news.map((item, index) => (
              <tr key={index}>
                <td>{item.title}</td>
                <td>{item.enabled === 'true' ? 'Published' : 'Draft'}</td>
                <td>{item.start_date}</td>
                <td>{item.venue ?? ''}</td>
                <td className="text-end">
                  <Link to={`/calendar-events/edit/${item.id}`}>
                    <ActionButton icon="edit" title="Edit" variant="action" className="p-0 me-2" />
                  </Link>
                  <ActionButton
                    icon="trash-alt"
                    title="Delete"
                    variant="action"
                    className="p-0"
                    onClick={() => archiveArticle(item.id, item.title)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default ListCalendarEvents;
